import { ChangeDetectorRef, Component, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';

@Component({
  selector: 'gtd-crm-questions',
  templateUrl: './crm-questions.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CrmQuestionsFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CrmQuestionsFieldComponent),
      multi: true,
    },
  ],
})
@DestroySubscribers()
export class CrmQuestionsFieldComponent implements OnInit, ControlValueAccessor, Validator {
  constructor(private cd: ChangeDetectorRef) {}
  public types = {
    select: $localize`:@@common.select:Select`,
    radio: $localize`:@@common.radio:Radio`,
    text: $localize`:@@common.text:Text`,
    checkbox: $localize`:@@common.checkbox:Checkbox`,
    countryRegion: $localize`:@@common.country_and_region:Country And Region`,
  };
  public form = new CrmQuestionsFormGroup({
    question: new UntypedFormControl(null, Validators.required),
    type: new UntypedFormControl(null, Validators.required),
    answers: new UntypedFormArray([]),
  });
  public subscribers: Record<string, Subscription> = {};

  public disabledAddControlButton = false;
  private onChange: (value: any) => void = () => {};
  private onTouch = () => {};

  public addForm(): void {
    this.form.controls.answers.push(new UntypedFormControl(null, Validators.required));
  }

  public removeForm(i: number): void {
    this.form.controls.answers.removeAt(i);
  }

  public typeChange(value: string) {
    if (value === 'text' || value === 'countryRegion') {
      this.form.controls.answers.clear();
      this.disabledAddControlButton = true;
    } else {
      this.disabledAddControlButton = false;
    }
  }

  public writeValue(obj: any): void {
    try {
      const value = JSON.parse(obj);
      value.answers.forEach(() => this.addForm());
      this.form.patchValue(value);
      this.cd.detectChanges();
    } catch {}
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public validate(): ValidationErrors | null {
    switch (true) {
      case this.form.invalid:
      case this.form.controls.type.value !== 'text' &&
        this.form.controls.type.value !== 'countryRegion' &&
        !this.form.controls.answers.length:
        return { errors: true };
      default:
        return null;
    }
  }

  public ngOnInit(): void {
    this.subscribers.formChanges = this.form.valueChanges.pipe(debounceTime(100)).subscribe((value) => {
      this.onChange(JSON.stringify(value));
      this.onTouch();
    });
  }
}

class CrmQuestionsFormGroup extends UntypedFormGroup {
  controls: {
    question: UntypedFormControl;
    type: UntypedFormControl;
    answers: UntypedFormArray;
  };
}
